import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProdutoEtapaModalidade } from '../../../models/produto-etapa-modalidade.model';
import { ProdutoEtapaModalidadeService } from '../../../services/produto-etapa-modalidade.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-produto-etapa-modalidade-list',
  templateUrl: './produto-etapa-modalidade-list.component.html',
  styleUrls: ['./produto-etapa-modalidade-list.component.scss'],
})
export class ProdutoEtapaModalidadeListComponent
  extends BaseListComponent<ProdutoEtapaModalidade>
  implements OnInit, OnDestroy
{
  etapaList: ProdutoEtapaModalidade[];

  constructor(
    private myService: ProdutoEtapaModalidadeService,
    public activatedRoute: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.etapaList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/pre-projeto/admin/produto-etapa-modalidade/adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto/admin/produto-etapa-modalidade/', id];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}
